module.exports = __webpack_public_path__ + "static/media/0-4.e1d1a052.svg";